import * as React from "react";

function SvgSliderArrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={26}
      height={26}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={13} cy={13} r={12.5} fill="#fff" stroke="#101839" />
      <path
        d="M14 10l-3 3 3 3"
        stroke="#101839"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default SvgSliderArrow;
